import React, { useState, useEffect } from "react";
import { Tab } from '@headlessui/react'
import SamplesProv from "./SamplesProv";
import SamplesDist from "./SamplesDist";
import SellPointsStatus from "./SellPointsStatus";

const MainTab = (props) => {

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    let [categories] = useState({
        'Muestras Provincias': [
            {
                title: <SamplesProv />,
            },
        ],
        'Muestras Distrito': [
            {
                title: <SamplesDist />,
            },
        ],
        'Estado de Negocio': [
            {
                title: <SellPointsStatus />,
            },
        ]
    })

    useEffect(() => {
    }, [])

    return (


        <div className="">
            <Tab.Group>
                <Tab.List className="flex space-x-1 rounded-xl bg-blue-900/20 p-1">
                    {Object.keys(categories).map((category) => (
                        <Tab
                            key={category}
                            className={({ selected }) =>
                                classNames(
                                    'w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-blue-700',
                                    'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                                    selected
                                        ? 'bg-white shadow'
                                        : 'text-blue-100 hover:bg-white/[0.12] hover:text-white'
                                )
                            }
                        >
                            {category}
                        </Tab>
                    ))}
                </Tab.List>
                <Tab.Panels className="mt-2">
                    {Object.values(categories).map((posts, idx) => (
                        <Tab.Panel
                            key={idx}
                            className=""
                        >
                            <ul>
                                {posts.map((post) => (
                                    <li
                                        key={post.id}
                                        className="relative rounded-md p-3 hover:bg-gray-100"
                                    >
                                        <h3 className=" font-medium">
                                            {post.title}
                                        </h3>
                                        
                                    </li>
                                ))}
                            </ul>
                        </Tab.Panel>
                    ))}
                </Tab.Panels>
            </Tab.Group>
        </div>
    )
}

export default MainTab